import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Banner, Box, Button, Dialog, Icon } from '@node-space/ui-components'
import { useDevXContext } from 'hooks/useDevXContext'

export const SandboxGoLiveCTA = () => {
  const { t } = useTranslation()
  const [showModal, setShowModal] = useState(false)
  const { setIsDevXGoLiveReady } = useDevXContext()

  const handleContactSalesOnClick = () => {
    setIsDevXGoLiveReady(true)
    window.open(`${process.env.CONTACT_SALES_URL}`)
  }

  return (
    <>
      <Banner variant="warning">
        <Box tag="span" flex gapX={8} align="center">
          <Icon name="Flask" />
          <span>
            {t('sandboxTestData')}
            {' • '}
            <Button
              variant="ghost"
              style={{ height: '20px', padding: '0px' }}
              onClick={() => setShowModal(true)}
            >
              Go live
            </Button>
          </span>
        </Box>
      </Banner>
      <Dialog
        title={t('getStarted.howToGoLive')}
        type="utility"
        open={showModal}
        onClose={() => setShowModal(false)}
        ActionButtons={[
          <Button key="contactSales" onClick={handleContactSalesOnClick}>
            {t('contactSales')}
          </Button>,
        ]}
      >
        <p className="text-foreground-prominent text-body-regular">
          {t('getStarted.goLiveDescription')}
        </p>
      </Dialog>
    </>
  )
}
